export const kanpaiinfinityNFTs = [
  

  {
    "id": "kanpaipanda-250",
    "name": "Kanpai Pandas Infinity #250",
    "image": "https://ipfs.io/ipfs/bafybeibxmuishdxqifn4qqklicbkba4r7ws2axdwwfvdo4fpgxunjcchva",
    "price": "4.8 ETH"
  },
  {
    "id": "kanpaipanda-249",
    "name": "Kanpai Pandas Infinity #249",
    "image": "https://ipfs.io/ipfs/bafybeif57ojnz3yiar4htogru7l6qxzqz2gllhdpzt3ndhvhsvg6zvwhiq",
    "price": "4.2 ETH"
  },
  {
    "id": "kanpaipanda-248", 
    "name": "Kanpai Pandas Infinity #248",
    "image": "https://ipfs.io/ipfs/bafybeiaaa4izmn7kn6eo5kgntyam6jgm3ajyxl7he3s7oj2u6wbva4mobu",
    "price": "4.9 ETH"
  },
  {
    "id": "kanpaipanda-247",
    "name": "Kanpai Pandas Infinity #247",
    "image": "https://ipfs.io/ipfs/bafybeibc37nlf5eufdpccrhavn63lxgavuci77gk2bt26ylorw2pwwdcte",
    "price": "3.9 ETH"
  },
  {
    "id": "kanpaipanda-246",
    "name": "Kanpai Pandas Infinity #246",
    "image": "https://ipfs.io/ipfs/bafybeier4b55suggaxirndzilil5krwxpm53skfxjvsnjehp4q6co423ya",
    "price": "4.5 ETH"
  },
  {
    "id": "kanpaipanda-245",
    "name": "Kanpai Pandas Infinity #245",
    "image": "https://ipfs.io/ipfs/bafybeicuydnhavgowsyew5tvehhthgmwrggtxzmv7o6pxqw3yxq3rkegr4",
    "price": "3.8 ETH"
  },
  {
    "id": "kanpaipanda-244",
    "name": "Kanpai Pandas Infinity #244",
    "image": "https://ipfs.io/ipfs/bafybeieajz4vlcqm7hvpvmtmhtvhmdw3r7drlbmkmctfcwrr4tkbjymmre",
    "price": "4.7 ETH"
  },
  {
    "id": "kanpaipanda-243",
    "name": "Kanpai Pandas Infinity #243",
    "image": "https://ipfs.io/ipfs/bafybeigjh52u243iikeogbbypg6axsqikbtrcyjr6w6s6bs7nt3jux6iue",
    "price": "4.1 ETH"
  },
  {
    "id": "kanpaipanda-242",
    "name": "Kanpai Pandas Infinity #242",
    "image": "https://ipfs.io/ipfs/bafybeiesphnka6chzult6rd7p6riukb7ny4zeegnd5cw3mv4mytbdq5lj4",
    "price": "5.0 ETH"
  },
  {
    "id": "kanpaipanda-241",
    "name": "Kanpai Pandas Infinity #241",
    "image": "https://ipfs.io/ipfs/bafybeibts44azmja6bveyzasn64lxrpt3fmptepvvum4k7qbzcsvuszkca",
    "price": "4.3 ETH"
  },
  {
    "id": "kanpaipanda-240",
    "name": "Kanpai Pandas Infinity #240",
    "image": "https://ipfs.io/ipfs/bafybeigncohpnmjiu6mr6ymgg4cop4fnlvt3zzrzwedyz77royfbtwhe2a",
    "price": "3.7 ETH"
  },
  {
    "id": "kanpaipanda-239",
    "name": "Kanpai Pandas Infinity #239",
    "image": "https://ipfs.io/ipfs/bafybeidoymhogzfvjjxuma56vjn5cwnvn4xy7qqqxvncq73gytmzzcncja",
    "price": "4.6 ETH"
  },
  {
    "id": "kanpaipanda-238",
    "name": "Kanpai Pandas Infinity #238",
    "image": "https://ipfs.io/ipfs/bafybeihhlobznjhanrkinhyute7fqn6qfxgz6ah2inqv5v4aus5njblti4",
    "price": "4.0 ETH"
  },
  {
    "id": "kanpaipanda-237",
    "name": "Kanpai Pandas Infinity #237",
    "image": "https://ipfs.io/ipfs/bafybeihgpsvqwbxgmjyvsnwx4rjq2cr6zt3cskv2qf3eqdfwuxmzt4h5tm",
    "price": "4.8 ETH"
  },
  {
    "id": "kanpaipanda-236",
    "name": "Kanpai Pandas Infinity #236",
    "image": "https://ipfs.io/ipfs/bafybeidly5ioutt6axonovc6duo7x2qnkiodvm2eujgt6cmyi4gq4qmqvm",
    "price": "4.4 ETH"
  },
    
  {
    "id": "kanpaipanda-235",
    "name": "Kanpai Pandas Infinity #235",
    "image": "https://ipfs.io/ipfs/bafybeieir7w4qij5tjxsc53tyfggw2ry7oq2h7x3eqygzdopirlmoaehmq",
    "price": "3.8 ETH"
  },
  {
    "id": "kanpaipanda-234",
    "name": "Kanpai Pandas Infinity #234",
    "image": "https://ipfs.io/ipfs/bafybeieuehdr5bpxreasw77dqssbgvnekhnhrzt4rkmodzyjkazjs42cfe",
    "price": "4.7 ETH"
  },
  {
    "id": "kanpaipanda-233",
    "name": "Kanpai Pandas Infinity #233",
    "image": "https://ipfs.io/ipfs/bafybeig3yupyprwykf7ggqap5wvq2iq2s6bsn4beykvqzleb7itaieb4p4",
    "price": "4.2 ETH"
  },
  {
    "id": "kanpaipanda-232",
    "name": "Kanpai Pandas Infinity #232",
    "image": "https://ipfs.io/ipfs/bafybeib4x6ynky42bbiy4tariavhag5ve7aaekppqgaytfoj23u2ojfiqq",
    "price": "4.9 ETH"
  },
  {
    "id": "kanpaipanda-231",
    "name": "Kanpai Pandas Infinity #231",
    "image": "https://ipfs.io/ipfs/bafybeidflsb4wykjv7domu5rkhzbt27r2qqpyjsjc3eo3bcami7bkqbjoe",
    "price": "3.9 ETH"
  },
  {
    "id": "kanpaipanda-230",
    "name": "Kanpai Pandas Infinity #230",
    "image": "https://ipfs.io/ipfs/bafybeic2efyhmg2zx72ik52skf44u4i7o5l2zgdhtnk5z5xjwxnbnticbu",
    "price": "4.5 ETH"
  },
  {
    "id": "kanpaipanda-229",
    "name": "Kanpai Pandas Infinity #229",
    "image": "https://ipfs.io/ipfs/bafybeignpdcy4cwbh2veyybwdy2xjltcjgajdauumoz2p5z2qermwpuf4q",
    "price": "3.7 ETH"
  },
  {
    "id": "kanpaipanda-228",
    "name": "Kanpai Pandas Infinity #228",
    "image": "https://ipfs.io/ipfs/bafybeifqbsj4rmnnrnb25jljvpno2emvbsnutzj2jxs6wh77qdx6swpmce",
    "price": "4.8 ETH"
  },
  {
    "id": "kanpaipanda-227",
    "name": "Kanpai Pandas Infinity #227",
    "image": "https://ipfs.io/ipfs/bafybeia6d6ysvestknymyctswsn244vwbz5ciurcyrgufp35fysuu7hnhy",
    "price": "4.3 ETH"
  },
  {
    "id": "kanpaipanda-226",
    "name": "Kanpai Pandas Infinity #226",
    "image": "https://ipfs.io/ipfs/bafybeiaa24ch4gldnuiwlkdmx5s7xzrerhdkmmtowilpvsh4tggtadevd4",
    "price": "5.0 ETH"
  },
  {
    "id": "kanpaipanda-225",
    "name": "Kanpai Pandas Infinity #225",
    "image": "https://ipfs.io/ipfs/bafybeigg7eib7cwfqpja7dzv56cii6vas26hh4splapelzwgkkir6rigky",
    "price": "4.1 ETH"
  },
  {
    "id": "kanpaipanda-224",
    "name": "Kanpai Pandas Infinity #224",
    "image": "https://ipfs.io/ipfs/bafybeiepla5ucr666ktpnclxhjfvrzyatwq4bedkzjd26hqehnpynbbbi4",
    "price": "4.6 ETH"
  },
  {
    "id": "kanpaipanda-223",
    "name": "Kanpai Pandas Infinity #223",
    "image": "https://ipfs.io/ipfs/bafybeigihej34ggoprthpxfzmsouu5r7dktd7q7xaltfwpx2th7rn77vrq",
    "price": "3.8 ETH"
  },
  {
    "id": "kanpaipanda-222",
    "name": "Kanpai Pandas Infinity #222",
    "image": "https://ipfs.io/ipfs/bafybeifr6yp4q76ygmhqpgil4pg4yl737gxiocqpwdpifcniq6qvz757hi",
    "price": "4.7 ETH"
  },
  {
    "id": "kanpaipanda-221",
    "name": "Kanpai Pandas Infinity #221",
    "image": "https://ipfs.io/ipfs/bafybeicn73detezyfhuysbv4pnnwzlxidjibktbkomrxdybcevsmbul3ce",
    "price": "4.4 ETH"
  },
  {
    "id": "kanpaipanda-220",
    "name": "Kanpai Pandas Infinity #220",
    "image": "https://ipfs.io/ipfs/bafybeid2fiawtkqtaq6stzukw5r4u7xvrv2znraw27sow7hwk2u72ajkla",
    "price": "4.9 ETH"
  },
  {
    "id": "kanpaipanda-219",
    "name": "Kanpai Pandas Infinity #219",
    "image": "https://ipfs.io/ipfs/bafybeigbxvo6jvpyi6zt6fsumi3ca63vwoqt3vgom7tnxvxn6wetg32pj4",
    "price": "3.9 ETH"
  },
  {
    "id": "kanpaipanda-218",
    "name": "Kanpai Pandas Infinity #218",
    "image": "https://ipfs.io/ipfs/bafybeidcubj2oqsuegqtlff2blwklus434dsgwbq7bs5zebtm2jqczpf2q",
    "price": "4.5 ETH"
  },
  {
    "id": "kanpaipanda-217",
    "name": "Kanpai Pandas Infinity #217",
    "image": "https://ipfs.io/ipfs/bafybeibmvsgjwptc6nwfwbpquj7karw5ebu7wxb2zal4xqyh4g3frbppqq",
    "price": "3.7 ETH"
  },
  {
    "id": "kanpaipanda-216",
    "name": "Kanpai Pandas Infinity #216",
    "image": "https://ipfs.io/ipfs/bafybeibjf6b67dcq5cwsezmgccywnr4kf25jpm6ghgmhro7k345jfclgoq",
    "price": "4.8 ETH"
  },
  {
    "id": "kanpaipanda-215",
    "name": "Kanpai Pandas Infinity #215",
    "image": "https://ipfs.io/ipfs/bafybeiaxc6xvc5phkmeekv6sros4awyjgalvb2kj6e4mcibo4jcyq2cslq",
    "price": "4.2 ETH"
  },
  {
    "id": "kanpaipanda-214",
    "name": "Kanpai Pandas Infinity #214",
    "image": "https://ipfs.io/ipfs/bafybeifqpnrfmk3wmlrm6n7gcdhwe262ubyz3gklqb2uusfosvuvoo76ii",
    "price": "5.0 ETH"
  },
  {
    "id": "kanpaipanda-213",
    "name": "Kanpai Pandas Infinity #213",
    "image": "https://ipfs.io/ipfs/bafybeihvgaxmci233eyhdsu34xpyjrept6zhufbtzdw6j4eyiywumgw7fy",
    "price": "4.3 ETH"
  },
  {
    "id": "kanpaipanda-212",
    "name": "Kanpai Pandas Infinity #212",
    "image": "https://ipfs.io/ipfs/bafybeigtpj3eurmt3drmgj7kwrqtnhsiab2jk3uhnchi2nk6xs55ec7dpm",
    "price": "4.6 ETH"
  },
  {
    "id": "kanpaipanda-211",
    "name": "Kanpai Pandas Infinity #211",
    "image": "https://ipfs.io/ipfs/bafybeignqix7rkchnds74gul2cfmfsfvuis3gj37g5v3pxymmumgo23ema",
    "price": "3.8 ETH"
  },
  {
    "id": "kanpaipanda-210",
    "name": "Kanpai Pandas Infinity #210",
    "image": "https://ipfs.io/ipfs/bafybeicqjmd73c2xupe3bsox6zmmgcdhn6tmbx4dmawzbhcw4fpscmhiu4",
    "price": "4.7 ETH"
  },
  {
    "id": "kanpaipanda-209",
    "name": "Kanpai Pandas Infinity #209",
    "image": "https://ipfs.io/ipfs/bafybeidheutgzdaha7ecxkddgs7s4rjpykk4rcgvyusnyzvy7jwx564gvm",
    "price": "4.1 ETH"
  },
  {
    "id": "kanpaipanda-208",
    "name": "Kanpai Pandas Infinity #208",
    "image": "https://ipfs.io/ipfs/bafybeiazmvq4dhkjxhdosauvbb36rl7wxcnoxuiy4d3avragksel5l2abq",
    "price": "4.9 ETH"
  },
  {
    "id": "kanpaipanda-207",
    "name": "Kanpai Pandas Infinity #207",
    "image": "https://ipfs.io/ipfs/bafybeig2oahcx34mgnp3ktm4x5ykulyb6wlc5zbftyuawzpgt2sjc5l2ui",
    "price": "3.9 ETH"
  },
  {
    "id": "kanpaipanda-206",
    "name": "Kanpai Pandas Infinity #206",
    "image": "https://ipfs.io/ipfs/bafybeicnhbtudiervqstoaz6fg6jydklookuajmrjoeoaxvlfffmyddr6i",
    "price": "4.5 ETH"
  },
  {
    "id": "kanpaipanda-205",
    "name": "Kanpai Pandas Infinity #205",
    "image": "https://ipfs.io/ipfs/bafybeihfo26ukd5jaqude2fne3xotxhvlkg7wtjxmji44e6vyqd2no7hza",
    "price": "3.7 ETH"
  },
  {
    "id": "kanpaipanda-204",
    "name": "Kanpai Pandas Infinity #204",
    "image": "https://ipfs.io/ipfs/bafybeidaqbrkumapk2capuitk6qshw5jdaqtzux4o65oxnq75lnbegy6he",
    "price": "4.8 ETH"
  },
  {
    "id": "kanpaipanda-203",
    "name": "Kanpai Pandas Infinity #203",
    "image": "https://ipfs.io/ipfs/bafybeie4uzqvyh57ruimyzwl6lix4suw6txn7ce5tbhflyicaomxwtxaqe",
    "price": "4.4 ETH"
  },
  {
    "id": "kanpaipanda-202",
    "name": "Kanpai Pandas Infinity #202",
    "image": "https://ipfs.io/ipfs/bafybeie5f5c3se3d2xxyo4jkhivchn6i6fxrtv2nqrslh6wvkkoxsb52z4",
    "price": "5.0 ETH"
  },
  {
    "id": "kanpaipanda-201",
    "name": "Kanpai Pandas Infinity #201",
    "image": "https://ipfs.io/ipfs/bafybeiguscjdm4cz7gzyu66ai2fohoqhxjgvqt37covcax3fouudoe7kii",
    "price": "4.2 ETH"
  },
  {
    "id": "kanpaipanda-200",
    "name": "Kanpai Pandas Infinity #200",
    "image": "https://ipfs.io/ipfs/bafybeiesgelth4w5quvf3u4yq6ckfwmf4ou2v4cskn442gbn3ucoovmnd4",
    "price": "4.6 ETH"
  },
  {
    "id": "kanpaipanda-199",
    "name": "Kanpai Pandas Infinity #199",
    "image": "https://ipfs.io/ipfs/bafybeifd5sgogoegmq6loqzzwvcxuuzy2atg64n2gwn3wb7fty5qib6t5q",
    "price": "3.8 ETH"
  },
  {
    "id": "kanpaipanda-198",
    "name": "Kanpai Pandas Infinity #198",
    "image": "https://ipfs.io/ipfs/bafybeibop4ssycxjj7ldwn5fqln4ztauxv266wtszmify62mynyjnbhsni",
    "price": "4.7 ETH"
  },
  {
    "id": "kanpaipanda-197",
    "name": "Kanpai Pandas Infinity #197",
    "image": "https://ipfs.io/ipfs/bafybeidycprmpmfwo7vsnauhzj5nlgerfzp5duxme54pjtovj4j3p2mopy",
    "price": "4.3 ETH"
  },
  {
    "id": "kanpaipanda-196",
    "name": "Kanpai Pandas Infinity #196",
    "image": "https://ipfs.io/ipfs/bafybeigi4yuvid2q334c7xsixmpk64vekk3lngznubh3mtgtunsuaowf6m",
    "price": "4.9 ETH"
  },
    
  {
    "id": "kanpaipanda-195",
    "name": "Kanpai Pandas Infinity #195",
    "image": "https://ipfs.io/ipfs/bafybeiezlwcqadxnjcuf4vlnalej2fmjnec76poduyenjmiqcbxn7hy3te",
    "price": "4.1 ETH"
  },
  {
    "id": "kanpaipanda-194",
    "name": "Kanpai Pandas Infinity #194",
    "image": "https://ipfs.io/ipfs/bafybeig6lru35gyboonctdcnt6qpqnbpww4woohrodym5fjokndfqjmp54",
    "price": "4.6 ETH"
  },
  {
    "id": "kanpaipanda-193",
    "name": "Kanpai Pandas Infinity #193",
    "image": "https://ipfs.io/ipfs/bafybeic725a5gebcbqcyk2lneudynrvk3eqqkaw2rzgjdhyjsqssgrkni4",
    "price": "3.8 ETH"
  },
  {
    "id": "kanpaipanda-192",
    "name": "Kanpai Pandas Infinity #192",
    "image": "https://ipfs.io/ipfs/bafybeibxm6tqsqnlltx6lyal2dxlsmrnlk64ulluxx2zbfireixzm3eiuq",
    "price": "4.7 ETH"
  },
  {
    "id": "kanpaipanda-191",
    "name": "Kanpai Pandas Infinity #191",
    "image": "https://ipfs.io/ipfs/bafybeidf6x7yb24q3s6opb77b4h7ty6xxvl3bvqpd277mf6nvrtdvxozyu",
    "price": "4.4 ETH"
  },
  {
    "id": "kanpaipanda-190",
    "name": "Kanpai Pandas Infinity #190",
    "image": "https://ipfs.io/ipfs/bafybeicq34ohr56ugbuotp2hvthj644hucb2usgerwywabz3az5qox7e4u",
    "price": "4.9 ETH"
  },
  {
    "id": "kanpaipanda-189",
    "name": "Kanpai Pandas Infinity #189",
    "image": "https://ipfs.io/ipfs/bafybeih7l4rt2sihnu2nlotcedtqeg534xlmq3rwrymbiih7evhflmtqim",
    "price": "3.9 ETH"
  },
  {
    "id": "kanpaipanda-188",
    "name": "Kanpai Pandas Infinity #188",
    "image": "https://ipfs.io/ipfs/bafybeiekfje3lsh37silfmbtbrdnqp2tbmkqvixy34y4tvmq5aldf5kb3u",
    "price": "4.5 ETH"
  },
  {
    "id": "kanpaipanda-187",
    "name": "Kanpai Pandas Infinity #187",
    "image": "https://ipfs.io/ipfs/bafybeiafozlqgkoqury4cxcu36nmyxhwjpqij2oguldeygaxunwdntomiy",
    "price": "3.7 ETH"
  },
  {
    "id": "kanpaipanda-186",
    "name": "Kanpai Pandas Infinity #186",
    "image": "https://ipfs.io/ipfs/bafybeibwmyolj6nx34mj3ymh6bolm6kvukq6ldmdgrg6ttfmrjmhux2bzu",
    "price": "4.8 ETH"
  },
  {
    "id": "kanpaipanda-185",
    "name": "Kanpai Pandas Infinity #185",
    "image": "https://ipfs.io/ipfs/bafybeidpnltg6tp3reyf65ukmxn42ll7m3s2qnyzstfjszg2355frb7z3a",
    "price": "4.2 ETH"
  },
  {
    "id": "kanpaipanda-184",
    "name": "Kanpai Pandas Infinity #184",
    "image": "https://ipfs.io/ipfs/bafybeifzkfmzxzeq7rgzy623sebsqtww45annc4xypmuhtvikbv635adue",
    "price": "5.0 ETH"
  },
  {
    "id": "kanpaipanda-183",
    "name": "Kanpai Pandas Infinity #183",
    "image": "https://ipfs.io/ipfs/bafybeidoaavjiulr6dm76kftdbd76incp24jbk4bxfznsrjzrdadifbb7e",
    "price": "4.3 ETH"
  },
  {
    "id": "kanpaipanda-182",
    "name": "Kanpai Pandas Infinity #182",
    "image": "https://ipfs.io/ipfs/bafybeihmg4fkrn6pzelftid7s6svi2odny3smdiyf5aidoq4prrseu6dym",
    "price": "4.6 ETH"
  },
  {
    "id": "kanpaipanda-181",
    "name": "Kanpai Pandas Infinity #181",
    "image": "https://ipfs.io/ipfs/bafybeifdnxwiknh5rem5kx644mam5qzbhbulpiep2uehvrxchsevwddqui",
    "price": "3.8 ETH"
  },
  {
    "id": "kanpaipanda-180",
    "name": "Kanpai Pandas Infinity #180",
    "image": "https://ipfs.io/ipfs/bafybeie77pck5m4ota7kit3od2un4jhuwpovmknlq7b4ciuvrokxdgi4qu",
    "price": "4.7 ETH"
  },
  {
    "id": "kanpaipanda-179",
    "name": "Kanpai Pandas Infinity #179",
    "image": "https://ipfs.io/ipfs/bafybeigdqj23nottgqmn2ipqtnwcnvk5s6j7ljbh6c3bkyqsfuoygx6ahe",
    "price": "4.1 ETH"
  },
  {
    "id": "kanpaipanda-178",
    "name": "Kanpai Pandas Infinity #178",
    "image": "https://ipfs.io/ipfs/bafybeib3u4uskdzrv2wn7ojo7gy2el4jxjmop3ydwnzflzhufv24nzapy4",
    "price": "4.9 ETH"
  },
  {
    "id": "kanpaipanda-177",
    "name": "Kanpai Pandas Infinity #177",
    "image": "https://ipfs.io/ipfs/bafybeiapcucfipginl3yvojc2i56fcrrn6tsm7lhkkdzc52rgv6vkspyve",
    "price": "3.9 ETH"
  },
  {
    "id": "kanpaipanda-176",
    "name": "Kanpai Pandas Infinity #176",
    "image": "https://ipfs.io/ipfs/bafybeibm5b5l4ojniqsl5drtliuuhnrlekuz3b33lmuzf2ph5kp2ivuvbq",
    "price": "4.5 ETH"
  },
  {
    "id": "kanpaipanda-175",
    "name": "Kanpai Pandas Infinity #175",
    "image": "https://ipfs.io/ipfs/bafybeigwspb5gzwbjkz754frobrs6yruvmsaahtpg7wdnv7a23ldeztxwu",
    "price": "3.7 ETH"
  },
  {
    "id": "kanpaipanda-174",
    "name": "Kanpai Pandas Infinity #174",
    "image": "https://ipfs.io/ipfs/bafybeibhjemgysntg6orgol7qpybljuyn5pfwvwsaepi7frofpulybocxm",
    "price": "4.8 ETH"
  },
  {
    "id": "kanpaipanda-173",
    "name": "Kanpai Pandas Infinity #173",
    "image": "https://ipfs.io/ipfs/bafybeigdm5t7aghbe4lodtdpxroz6u3r56r324ectfexg7jgul3qkicvua",
    "price": "4.4 ETH"
  },
  {
    "id": "kanpaipanda-172",
    "name": "Kanpai Pandas Infinity #172",
    "image": "https://ipfs.io/ipfs/bafybeib2dm7t6hl3gvyygr3r6wsiodth3xapodsehmqcov6rtgcdj752ui",
    "price": "5.0 ETH"
  },
  {
    "id": "kanpaipanda-171",
    "name": "Kanpai Pandas Infinity #171",
    "image": "https://ipfs.io/ipfs/bafybeic62qjqmg53luojfpmfu3653sg3ufr5ycjmgbqgxicekzst7zomwu",
    "price": "4.2 ETH"
  },
  {
    "id": "kanpaipanda-170",
    "name": "Kanpai Pandas Infinity #170",
    "image": "https://ipfs.io/ipfs/bafybeiddbz3qikccfgyhwf437kyengozt26hjs5ooaen6gnd74d2x2cp24",
    "price": "4.6 ETH"
  },
  {
    "id": "kanpaipanda-169",
    "name": "Kanpai Pandas Infinity #169",
    "image": "https://ipfs.io/ipfs/bafybeiemvifvbyq37gdy7j4vnsthgu5qhxobgnrfz2mefwceodj2z56u4q",
    "price": "3.8 ETH"
  },
  {
    "id": "kanpaipanda-168",
    "name": "Kanpai Pandas Infinity #168",
    "image": "https://ipfs.io/ipfs/bafybeiemqjat5fn7tk4vz5jmh3kuh7xropxkm22rcafxbausdvzns3se7y",
    "price": "4.7 ETH"
  },
  {
    "id": "kanpaipanda-167",
    "name": "Kanpai Pandas Infinity #167",
    "image": "https://ipfs.io/ipfs/bafybeiha3cjrt2egqcdzzvq4prcgiyuxkp6jfaqldq2kdbikjtq4ggl2tu",
    "price": "4.3 ETH"
  },
  {
    "id": "kanpaipanda-166",
    "name": "Kanpai Pandas Infinity #166",
    "image": "https://ipfs.io/ipfs/bafybeig3q3esfzl4atcrjnj4lolo6fkkitqwo5er2yijmlcqr2bucasbym",
    "price": "4.9 ETH"
  },
  {
    "id": "kanpaipanda-165",
    "name": "Kanpai Pandas Infinity #165",
    "image": "https://ipfs.io/ipfs/bafybeibw5dgdo3jw7whc4fn6yaooimf3lbeayzylswyoixqz3cat32kkuy",
    "price": "3.9 ETH"
  },
  {
    "id": "kanpaipanda-164",
    "name": "Kanpai Pandas Infinity #164",
    "image": "https://ipfs.io/ipfs/bafybeicptvfsb7daws6lz2cua63x4pjkr2aeuhulhjiwy2and53bfnj2x4",
    "price": "4.5 ETH"
  },
  {
    "id": "kanpaipanda-163",
    "name": "Kanpai Pandas Infinity #163",
    "image": "https://ipfs.io/ipfs/bafybeihv72pjcraum4ieloc3wefjgpsclnfb35rx6erufohg2ocmhtuvhu",
    "price": "3.7 ETH"
  },
  {
    "id": "kanpaipanda-162",
    "name": "Kanpai Pandas Infinity #162",
    "image": "https://ipfs.io/ipfs/bafybeiearfpygop7q22z4k4rl6rkbp2alywp4zy6fp3jcea3ene5vgrxba",
    "price": "4.8 ETH"
  },
  {
    "id": "kanpaipanda-161",
    "name": "Kanpai Pandas Infinity #161",
    "image": "https://ipfs.io/ipfs/bafybeihfil72bhw6x2vblfm4pisbsqc7h2hm7txnfn2kruow3pgv44frz4",
    "price": "4.2 ETH"
  },
  {
    "id": "kanpaipanda-160",
    "name": "Kanpai Pandas Infinity #160",
    "image": "https://ipfs.io/ipfs/bafybeig4exekgdajzhtlnrq7c3tew7bu2a2nz4xi2xaufg64a7ahrz7vse",
    "price": "5.0 ETH"
  },
  {
    "id": "kanpaipanda-159",
    "name": "Kanpai Pandas Infinity #159",
    "image": "https://ipfs.io/ipfs/bafybeicm5dqrxs3wnson74j6oodvqgdtu6aud3oph43sh3pmc6etjphl3q",
    "price": "4.4 ETH"
  },
  {
    "id": "kanpaipanda-158",
    "name": "Kanpai Pandas Infinity #158",
    "image": "https://ipfs.io/ipfs/bafybeieh3mesehrbbrdqisiovpsymqmi4ejvyqcvm5altuhyybqph45y7m",
    "price": "4.6 ETH"
  },
  {
    "id": "kanpaipanda-157",
    "name": "Kanpai Pandas Infinity #157",
    "image": "https://ipfs.io/ipfs/bafybeif7vdvubacrhupb6qesqeomp7vpiqcm3mhuycz2abwqntlvrf4poe",
    "price": "3.8 ETH"
  },
  {
    "id": "kanpaipanda-156",
    "name": "Kanpai Pandas Infinity #156",
    "image": "https://ipfs.io/ipfs/bafybeif42dofc3k4buv2p3bnybnkiisxfqd7buljsiuyeezjmisnwghb2m",
    "price": "4.7 ETH"
  },
  {
    "id": "kanpaipanda-155",
    "name": "Kanpai Pandas Infinity #155",
    "image": "https://ipfs.io/ipfs/bafybeic7kss5zu2ysexxmo5d6kkmqc4oko2syjmtigtkwr6bkifq6wruba",
    "price": "4.1 ETH"
  },
  {
    "id": "kanpaipanda-154",
    "name": "Kanpai Pandas Infinity #154",
    "image": "https://ipfs.io/ipfs/bafybeic3b4yvntjnptomv4dkin4bw2m54oww6rbu7mxadqftcnf6n4kgda",
    "price": "4.9 ETH"
  },
  {
    "id": "kanpaipanda-153",
    "name": "Kanpai Pandas Infinity #153",
    "image": "https://ipfs.io/ipfs/bafybeicsmjaed2ctspnuh422eqcla3sutkxvdb7fac6is4v2v4z54whfva",
    "price": "3.9 ETH"
  },
  {
    "id": "kanpaipanda-152",
    "name": "Kanpai Pandas Infinity #152",
    "image": "https://ipfs.io/ipfs/bafybeifta7dn2fso4y4vgu4wipwrh7x2gq4blzbbcolgxthwbcoux4i75y",
    "price": "4.5 ETH"
  },
  {
    "id": "kanpaipanda-151",
    "name": "Kanpai Pandas Infinity #151",
    "image": "https://ipfs.io/ipfs/bafybeigxhm6eregtms6r4fjsoqpjo5xz4zahtibsmpdird2zzpe5rltp7a",
    "price": "3.7 ETH"
  }





];